import { ThemeProvider, useColorScheme } from "@mui/material";
import { getTheme } from "@/style/theme.ts";
import { NuqsAdapter } from "nuqs/adapters/tanstack-router";
import type { Configuration } from "rollbar";
import { ErrorBoundary, Provider as RollbarProvider } from "@rollbar/react";
import AutoThemeSwitcher from "@/hoc/AutoThemeSwitcher.tsx";
import { getBrowserCompatibility } from "@/services/support.ts";

const rollbarConfig: Configuration = {
  accessToken: import.meta.env.VITE_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        code_version: "1.0.0",
        source_map_enabled: true,
      },
    },
  },
};

type ProvidersProps = {
  children: React.ReactNode;
};

const Providers = ({ children }: ProvidersProps) => {
  const theme = getTheme();
  const browserCompatibility = getBrowserCompatibility();

  const rollbarConfig: Configuration = {
    enabled: browserCompatibility.isCompatible,
    accessToken: import.meta.env.VITE_ROLLBAR_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      client: {
        javascript: {
          code_version: "1.0.0",
          source_map_enabled: true,
        },
      },
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <AutoThemeSwitcher>
        <RollbarProvider config={rollbarConfig}>
          <ErrorBoundary>
            <NuqsAdapter>{children}</NuqsAdapter>
          </ErrorBoundary>
        </RollbarProvider>
      </AutoThemeSwitcher>
    </ThemeProvider>
  );
};

export default Providers;
